import { Box } from '@mui/material';
import usePageTitle from 'hooks/usePageTitle';
import Tabs, { ITab } from 'DesignSystem/Primitives/Tabs/Tabs';
import React, { FC } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';

type TabType = 'active' | 'invalid' | 'in-progress';

const PRODUCT_TABS: ITab[] = [
  {
    key: 'active',
    label: 'Active',
  },
  {
    key: 'invalid',
    label: 'Invalid',
  },
  {
    key: 'in-progress',
    label: 'In progress',
  },
];

const ImpactClaimLayout: FC = () => {
  usePageTitle('Impact claims');
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const selectedTab: TabType = pathname.split('/')[2] as TabType;

  const handleChangeTab = (tab: string) => {
    navigate(`/impact-claims/${tab}`);
  };

  return (
    <PageContainer>
      <PageTitle title="Impact claims" />

      <Box mt={3} mb={1}>
        <Tabs tabs={PRODUCT_TABS} selectedTab={selectedTab} onChange={handleChangeTab} />
      </Box>

      <Outlet />
    </PageContainer>
  );
};

export default ImpactClaimLayout;
